import { RichTextPreview } from '@/components/editor/rich-text-preview';
import { useIsPageEditor } from '@/hooks/use-is-page-editor';
import { normalizeRichTextContent } from '@/lib/rich-text/normalize-rich-text';
import { cn } from '@/lib/utils';

interface TextBlockProps {
  content?: unknown;
  className?: string;
}

export function TextBlock({ content, className }: TextBlockProps) {
  const isEditor = useIsPageEditor();
  const resolvedContent = normalizeRichTextContent(content);

  if (!resolvedContent) {
    return null;
  }

  return (
    <RichTextPreview
      mode={isEditor ? 'document' : 'trusted'}
      value={resolvedContent}
      className={cn('max-w-full', className)}
    />
  );
}
